import { render, staticRenderFns } from "./myvendors.vue?vue&type=template&id=70ae332b&scoped=true&"
import script from "./myvendors.vue?vue&type=script&lang=js&"
export * from "./myvendors.vue?vue&type=script&lang=js&"
import style0 from "./myvendors.vue?vue&type=style&index=0&id=70ae332b&lang=scss&scoped=true&"
import style1 from "./myvendors.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./myvendors.vue?vue&type=style&index=2&id=70ae332b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae332b",
  null
  
)

export default component.exports